import { createFileRoute } from "@tanstack/react-router";
import { IncomeModals } from "@/components/income/income-modals";
import IncomeStats from "@/components/income/income-stats";
import IncomeTable from "@/components/income/income-table";
import { Button } from "@/components/ui/button";
import { Toast } from "@/components/ui/toast";
import { useTranslate } from "@/hooks/use-translate";
import useAppStore from "@/store";
import { Plus } from "lucide-react";

export const Route = createFileRoute("/(dasboard)/finance/incomes")({
  component: IncomesPage,
});

function IncomesPage() {
  const store = useAppStore();
  const { t } = useTranslate();
  return (
    <>
      <IncomeModals />
      <Toast name="clipboard" message="Copy to clipboard" autoClose={2000} />

      <div className="max-w-7xl mx-auto">
        <header className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-4 gap-4">
          <h2 className="text-2xl font-semibold">{t("Incomes")}</h2>
          <Button
            onClick={() => {
              store.display.show("create_income");
            }}
          >
            <Plus className="w-4 h-4" />
            {t("Add an income")}
          </Button>
        </header>

        <IncomeStats />
        <div className="mt-4"></div>
        <IncomeTable />
      </div>
    </>
  );
}
